import { REGION } from "project.config";

export const M2H_VALUES: Set<string> = new Set(['m2h-online-us', 'm2h-online-eu', 'm2h-online-ca']);
export const P2R_VALUES: Set<string> = new Set(['p2r-walmart-us', 'p2r-walgreens-us', 'p2r-cvs-us']);
export const P2R_SHIPPING_METHOD_KEY: Record<string, string> = {
  '2677': 'p2r-walmart-store-pickup',
  '10056': 'p2r-walgreens-store-pickup',
  '30240': 'p2r-cvs-store-pickup',
};
export const M2H_SHIPPING_METHOD_KEY: Record<REGION, string> = {
  US: 'm2h-online-us',
  CA: 'm2h-online-ca',
  EU: 'm2h-online-eu',
};

export const P2R_DISTRIBUTION_CHANNEL_KEY: Record<string, string> = {
  'p2r-walmart-store-pickup': 'p2r-walmart-us',
  'p2r-walgreens-store-pickup': 'p2r-walgreens-us',
  'p2r-cvs-store-pickup': 'p2r-cvs-us',
};

export const P2RText = 'p2r';
export const M2HText = 'm2h';
export const P2RKind = 'p2rCart';
export const M2HKind = 'm2hCart';
export type CartKindType = typeof P2RKind | typeof M2HKind | 'unknown';

export function classifyCartKind(raw?: string): CartKindType {
  if (!raw) return 'unknown';
  const value = raw.trim();
  if (P2R_VALUES.has(value)) return P2RKind;
  if (M2H_VALUES.has(value)) return M2HKind;
  return 'unknown';
}

export const productCodeModeIsAny = 'any';
export const productCodeModeIsAll = 'all';

export const STANDARD_DELIVERY = 'Standard Delivery';
export const PRIORITY_DELIVERY = 'Priority Delivery';
export const OVERNIGHT_DELIVERY = 'Overnight Delivery';

export const M2H_FULFILLERID: Record<REGION, string> = {
  US: '100101',
  CA: '100101',
  EU: '100101',
};

export const DELIVERY_METHOD_LABELS: Record<string, string> = {
  'm2h-standard-delivery': STANDARD_DELIVERY,
  'm2h-priority-delivery': PRIORITY_DELIVERY,
  'm2h-overnight-delivery': OVERNIGHT_DELIVERY,
};

export const getDeliveryLabel = (backendValue: string): string => {
  return DELIVERY_METHOD_LABELS[backendValue] || 'Standard Delivery';
};

export const EMAIL_PREFERENCE = 'marketingPreferenceEmail';

export const DELIVERY_METHOD_TO_METHOD_CODE: Record<string, string> = {
  'm2h-standard-delivery': 'SD',
  'm2h-priority-delivery': 'PD',
  'm2h-overnight-delivery': 'OD',
};

export const DEFAULT_M2H_DELIVERY_METHOD = 'm2h-standard-delivery';
